import { operativeProcedureTypes } from "../../helpers/constants";

export const PROMScoreTimeIntervals = [
    { value: '6 weeks', label: '6 Weeks' },
    { value: '12 weeks', label: '12 Weeks' },
    { value: '6 months', label: '6 Months' },
    { value: '12 months', label: '12 Months' },
    { value: '2 years', label: '2 Years' },
]

export const PROMScoreTypes = {
    [operativeProcedureTypes.TKA.inLowerCase]: [
        { value: 'KOOS', label: 'KOOS', subScores: true, dataType: 'numeric', min: 0, max: 100, yAxisTickMarks: [0, 20, 40, 60, 80, 100] },
        { value: 'KOOS JR.', label: 'KOOS JR.', subScores: false, dataType: 'numeric', min: 0, max: 100, yAxisTickMarks: [0, 20, 40, 60, 80, 100] },
        { value: 'PROMIS-Global', label: 'PROMIS-Global', subScores: false, dataType: 'numeric', min: 0, max: 20, yAxisTickMarks: [0, 5, 10, 15, 20] },
        { value: 'KSS', label: 'KSS', subScores: false, dataType: 'numeric', min: 0, max: 100, yAxisTickMarks: [0, 20, 40, 60, 80, 100] },
        { value: 'Oxford Knee Score', label: 'Oxford Knee Score', subScores: false, dataType: 'numeric', min: 0, max: 48, yAxisTickMarks: [0, 12, 24, 36, 48] },
        { value: 'Forgotten Joint Score', label: 'Forgotten Joint Score', subScores: false, dataType: 'numeric', min: 0, max: 100, yAxisTickMarks: [0, 20, 40, 60, 80, 100] },
        { value: 'EQ5D', label: 'EQ5D', subScores: true, dataType: 'numeric', min: 1, max: 5, yAxisTickMarks: [1, 3, 5] },
    ],
    [operativeProcedureTypes.HIP.inLowerCase]: [
        { value: 'HOOS', label: 'HOOS', subScores: true, dataType: 'numeric', min: 0, max: 100, yAxisTickMarks: [0, 20, 40, 60, 80, 100]},
        { value: 'HOOS JR.', label: 'HOOS JR.', subScores: false, dataType: 'numeric', min: 0, max: 100, yAxisTickMarks: [0, 20, 40, 60, 80, 100] },
        { value: 'PROMIS-Global', label: 'PROMIS-Global', subScores: false, dataType: 'numeric', min: 0, max: 20, yAxisTickMarks: [0, 5, 10, 15, 20] }
    ],
    [operativeProcedureTypes.TSA.inLowerCase]: [
        { value: 'ASES', label: 'ASES', subScores: true, dataType: 'numeric', min: 0, max: 100, maxSubscore: 50, yAxisTickMarks: [0, 20, 40, 60, 80, 100], graphType: 'stacked' },
        { value: 'CS', label: 'Constant Score (CS)', subScores: true, dataType: 'numeric', min: 0, max: 100, maxSubscore: 40, yAxisTickMarks: [0, 20, 40, 60, 80, 100], graphType: 'stacked', sectionDivision: true, sections: ['Subjective Measures', 'Objective Measures'] },
        { value: 'VAS Pain', label: 'VAS (Pain)', subScores: false, dataType: 'numeric', min: 0, max: 10, yAxisTickMarks: [0, 2, 4, 6, 8, 10] },
        { value: 'SST', label: 'Simple Shoulder Test (SST)', subScores: false, dataType: 'numeric', min: 0, max: 12, yAxisTickMarks: [0, 3, 6, 9, 12] },
        { value: 'SANE', label: 'Single Assessment Numeric Evaluation (SANE)', subScores: false, dataType: 'percentage', min: 0, max: 100, yAxisTickMarks: [0, 20, 40, 60, 80, 100] }
    ]
}

export const scoreTypesForManualScore = ['KOOS', 'EQ5D', 'HOOS', 'ASES', 'CS'];

export const manualPromScoreFields = {
    'KOOS': [
        { label: 'Pain', fieldName: 'KOOSPain', type: 'KOOS Pain', color: '#59BE78', dataType: 'numeric', min: 0, max: 100 },
        { label: 'Symptom', fieldName: 'KOOSSymptom', type: 'KOOS Symptom', color: '#B07CD9', dataType: 'numeric', min: 0, max: 100 },
        { label: 'ADL', fullLabel: 'Activities of Daily Living', fieldName: 'KOOSADL', type: 'KOOS ADL', color: '#EDA542', dataType: 'numeric', min: 0, max: 100 },
        { label: 'Sports', fieldName: 'KOOSSports', type: 'KOOS Sports', color: '#E8545A', dataType: 'numeric', min: 0, max: 100 },
        { label: 'QOL', fullLabel: 'Quality of Life', fieldName: 'KOOSQOL', type: 'KOOS QOL', color: '#2DA0E0', dataType: 'numeric', min: 0, max: 100 }
    ],
    'EQ5D': [
        { label: 'Mobility', fieldName: 'EQ5DMobility', type: 'EQ5D Mobility', color: '#59BE78', dataType: 'numeric', min: 1, max: 5 },
        { label: 'Care', fieldName: 'EQ5DCare', type: 'EQ5D Care', color: '#B07CD9', dataType: 'numeric', min: 1, max: 5 },
        { label: 'Activity', fieldName: 'EQ5DActivity', type: 'EQ5D Activity', color: '#EDA542', dataType: 'numeric', min: 1, max: 5 },
        { label: 'Pain', fieldName: 'EQ5DPain', type: 'EQ5D Pain', color: '#E8545A', dataType: 'numeric', min: 1, max: 5 },
        { label: 'Anxiety', fieldName: 'EQ5DAnxiety', type: 'EQ5D Anxiety', color: '#2DA0E0', dataType: 'numeric', min: 1, max: 5 },
    ],
    'HOOS': [
        { label: 'Pain', fieldName: 'HOOSPain', type: 'HOOS Pain', color: '#59BE78', dataType: 'numeric', min: 0, max: 100 },
        { label: 'Symptom', fieldName: 'HOOSSymptom', type: 'HOOS Symptom', color: '#B07CD9', dataType: 'numeric', min: 0, max: 100 },
        { label: 'ADL', fieldName: 'HOOSADL', type: 'HOOS ADL', color: '#EDA542', dataType: 'numeric', min: 0, max: 100 },
        { label: 'Sport/Rec', fieldName: 'HOOSSports', type: 'HOOS Sports', color: '#E8545A', dataType: 'numeric', min: 0, max: 100 },
        { label: 'QOL', fieldName: 'HOOSQOL', type: 'HOOS QOL', color: '#2DA0E0', dataType: 'numeric', min: 0, max: 100 }
    ],
    'ASES': [
        { label: 'Pain', fieldName: 'ASESPain', type: 'ASES Pain', color: '#59BE78', dataType: 'numeric', min: 0, max: 50 },
        { label: 'Activities of Daily Living (ADL)', dashboardGraphLabel: 'ADL', fieldName: 'ASESADL', type: 'ASES ADL', color: '#B07CD9', dataType: 'numeric', min: 0, max: 50 }
    ],
    'CS': [
        { label: 'Pain', fieldName: 'CSPain', type: 'CS Pain', color: '#59BE78', section: 'Subjective Measures', dataType: 'numeric', min: 0, max: 15 },
        { label: 'Activities of Daily Living (ADL)', dashboardGraphLabel: 'ADL', fullLabel: 'Activities of Daily Living', fieldName: 'CSADL', type: 'CS ADL', color: '#B07CD9', section: 'Subjective Measures', dataType: 'numeric', min: 0, max: 20 },
        { label: 'Range of Motion', fullLabel: 'Range of Motion', dashboardGraphLabel: 'ROM', fieldName: 'CSROM', type: 'CS ROM', color: '#EDA542', section: 'Objective Measures', dataType: 'numeric', min: 0, max: 40 },
        { label: 'Strength', fieldName: 'CSStrength', type: 'CS Strength', color: '#E8545A', section: 'Objective Measures', dataType: 'numeric', min: 0, max: 25 }
    ]
}

export const CSVExportHeaders = {
    [operativeProcedureTypes.TKA.inLowerCase]: [
        { label: "CORI case ID", key: "caseID" },
        { label: "Case Date", key: "CaseDate" },
        { label: "Sex", key: "Sex" },
        { label: "Patient Age", key: "PatientAge" },
        { label: "BMI", key: "BMI" },
        { label: "Femur Size", key: "FemurSize" },
        { label: "Tibia Size", key: "TibiaSize" },
        { label: "Poly Thickness", key: "PolyThickness" },
        { label: "Implant Type", key: "ImplantType" },
        { label: "Gaps Collected", key: "GapsCollected" },
        { label: "Force Range", key: "ForceRange" },
        { label: "SW Version", key: "SWVersion" },
        { label: "Workflow", key: "CaseType" },
        { label: "Pre-op Plan ID", key: "VisionaireID" },
        { label: "Distal Femur Medial Resection (mm)", key: "DistalFemurMedialResection" },
        { label: "Distal Femur Lateral Resection (mm)", key: "DistalFemurLateralResection" },
        { label: "Posterior Femur Medial Resection (mm)", key: "PosteriorFemurMedialResection" },
        { label: "Posterior Femur Lateral Resection (mm)", key: "PosteriorFemurLateralResection" },
        { label: "Femur Rotation (°)", key: "FemurRotation" },
        { label: "Femur Varus/Valgus (°)", key: "FemurVarusValgus" },
        { label: "Femur Flexion (°)", key: "FemurFlexion" },
        { label: "Tibia Medial Resection (mm)", key: "MedialTibiaResection" },
        { label: "Tibia Lateral Resection (mm)", key: "LateralTibiaResection" },
        // { label: "Tibia Rotation (°)", key: "TibiaRotation" },
        { label: "Tibia Varus/Valgus (°)", key: "TibiaVarusValgus" },
        { label: "Tibia Slope (°)", key: "TibiaSlope" },
        { label: "Preop Leg Alignment (°)", key: "PreopLegAlignment" },
        { label: "Planned Leg Alignment (°)", key: "PlannedLegAlignment" },
        { label: "Postop Leg Alignment (°)", key: "PostopLegAlignment" },
        // { label: "Preop Max Extension (°)", key: "PreopMaxExtension" },
        // { label: "Preop Max Flexion (°)", key: "PreopMaxFlexion" },
        // { label: "Postop Max Extension (°)", key: "PostopMaxExtension" },
        // { label: "Postop Max Flexion (°)", key: "PostopMaxFlexion" },
        { label: "Setup Time (s)", key: "SetupTime" },
        { label: "Registration Time (s)", key: "RegistrationTime" },
        { label: "Planning Time (s)", key: "PlanningTime" },
        { label: "Bone Removal Time (s)", key: "BoneRemovalTime" },
        { label: "Postop Assessment Time (s)", key: "PostopAssessmentTime" },
        { label: "Total Procedure Time (s)", key: "TotalProcedureTime" },
        { label: "Comments", key: "Comments" },
        { label: "Comments Last Updated", key: "CommentsUpdatedDate" },
        { label: "Comments Updated By", key: "CommentsUpdatedBy" }
    ],
    [operativeProcedureTypes.HIP.inLowerCase]: [
        { label: "Patient ID", key: "PatientId" },
        { label: "Surgery Date", key: "CaseDate" },
        { label: "Sex", key: "Sex" },
        { label: "Patient Age", key: "PatientAge" },
        { label: "BMI", key: "BMI" },
        { label: "Operative Side", key: "OperativeSide" },
        { label: "Surgical Approach", key: "SurgicalApproach" },
        { label: "SW Version", key: "SWVersion" },
        { label: "APP Anteversion (°)", key: "AnteversionApp" },
        { label: "APP Inclination (°)", key: "InclinationApp" },
        { label: "FPP Anteversion (°)", key: "AnteversionXray" },
        { label: "FPP Inclination (°)", key: "InclinationXray" },
        { label: "Pelvic Tilt (°)", key: "PelvicTilt" },
        { label: "ASIS Distance (mm)", key: "AsisDistance" },
        { label: "Acetabular Distance (mm)", key: "AcetabularDistance" },
        { label: "Acetabular Diameter (mm)", key: "AcetabularDiameter" },
        { label: "Leg Length (mm)", key: "LegLength" },
        { label: "Offset (mm)", key: "Offset" },
        { label: "Registration Time (s)", key: "RegistrationTime" },
        { label: "Navigation Time (s)", key: "NavigationTime" },
        { label: "Total Time (s)", key: "TotalProcedureTime" },
        { label: "Comments", key: "Comments" },
        { label: "Comments Last Updated", key: "CommentsUpdatedDate" },
        { label: "Comments Updated By", key: "CommentsUpdatedBy" }
    ],
    [operativeProcedureTypes.TSA.inLowerCase]: [
        { label: "CORI case ID", key: "caseID" },
        { label: "Case Date", key: "CaseDate" },
        { label: "Sex", key: "Sex" },
        { label: "Patient Age", key: "PatientAge" },
        { label: "BMI", key: "BMI" },
        { label: "SW Version", key: "SWVersion" },
        { label: "Procedure", key: "ProcedureType" },
        { label: "Pre-op Plan ID", key: "VisionaireID" },
        { label: "Operative Side", key: "OperativeSide" },
        { label: "Implant Design", key: "ImplantDesign" },
        { label: "Poly Type", key: "BaseplateType" },
        { label: "Glenosphere", key: "GlenosphereSize" },
        { label: "Liner Thickness", key: "GlenosphereType" },
        { label: "Stem Size", key: "StemSize" },
        { label: "Body Type", key: "BodyType" },
        { label: "Head Size", key: "HeadSize" },
        { label: "Head Type", key: "HeadType" },
        { label: "Poly Size", key: "GlenoidSize" },
        { label: "Liner Type", key: "LinerType" },
        { label: "Humerus Inclination (°)", key: "HumerusInclination" },
        { label: "Humerus Version (°)", key: "HumerusVersion" },
        { label: "Humerus Resection Depth (mm)", key: "HumerusResectionDepth" },
        { label: "Glenoid Superior Resection Depth (mm)", key: "GlenoidSuperiorResectionDepth" },
        { label: "Glenoid Posterior Resection Depth (mm)", key: "GlenoidPosteriorResectionDepth" },
        { label: "Glenoid Inferior Resection Depth (mm)", key: "GlenoidInferiorResectionDepth" },
        { label: "Glenoid Anterior Resection Depth (mm)", key: "GlenoidAnteriorResectionDepth" },
        { label: "Center Screw Length (mm)", key: "CenterScrewLength" },
        { label: "Posterior Screw Length (mm)", key: "PosteriorScrewLength" },
        { label: "Posterior Screw Type", key: "PosteriorScrewType" },
        { label: "Superior Screw Length (mm)", key: "SuperiorScrewLength" },
        { label: "Superior Screw Type", key: "SuperiorScrewType" },
        { label: "Anterior Screw Length (mm)", key: "AnteriorScrewLength" },
        { label: "Anterior Screw Type", key: "AnteriorScrewType" },
        { label: "Inferior Screw Length (mm)", key: "InferiorScrewLength" },
        { label: "Inferior Screw Type", key: "InferiorScrewType" },
        { label: "Glenoid Native Inclination (°)", key: "GlenoidNativeInclination" },
        { label: "Glenoid Final Inclination (°)", key: "GlenoidFinalInclination" },
        { label: "Glenoid Native Version (°)", key: "GlenoidNativeVersion" },
        { label: "Glenoid Final Version (°)", key: "GlenoidFinalVersion" },
        { label: "Planned Acromiohumeral Distance (mm)", key: "PlannedAcromiohumeralDistance" },
        { label: "Achieved Acromiohumeral Distance (mm)", key: "AchievedAcromiohumeralDistance" },
        { label: "Planned Arm Length (mm)", key: "PlannedArmLength" },
        { label: "Achieved Arm Length (mm)", key: "AchievedArmLength" },
        { label: "Planned Lateralization (mm)", key: "PlannedLateralization" },
        { label: "Achieved Lateralization (mm)", key: "AchievedLateralization" },
        { label: "Setup Time (s)", key: "SetupTime" },
        { label: "Humeral Registration Time (s)", key: "HumeralRegistrationTime" },
        { label: "Humeral Cutting Time (s)", key: "HumeralCuttingTime" },
        { label: "Glenoid Registration Time (s)", key: "GlenoidRegistrationTime" },
        { label: "Glenoid Cutting Time (s)", key: "GlenoidCuttingTime" },
        { label: "Post-Op Time (s)", key: "PostOpTime" },
        { label: "Planning Time (s)", key: "PlanningTime" },
        { label: "Total Procedure Time (s)", key: "TotalProcedureTime" },
        { label: "Procedure type", key: "OperativeApproach" },
        { label: "Comments", key: "Comments" },
    ]
}

export const commentsEditorConfig = (customConfig = {}) => {
    return {
        placeholder: customConfig.placeholder || 'Write something...',
        toolbar: {
            items: [
                'heading',
                '|',
                'bold',
                'italic',
                'bulletedList',
                'numberedList',
                '|',
                'indent',
                'outdent',
                '|',
                'undo',
                'redo'
            ]
        },
        height: customConfig.height || 100,
        enterMode: 'p', // CKEditor 5 uses paragraph tags by default
    };
};
